import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  CustomDialog,
  ModalAddIndividu,
  ModalAddSociete,
  ModalCorrespondanceActif,
} from "..";
import { FormAddActif } from "..";
import { Actif, User, Societe, Individu } from "../../interfaces";

interface ModalAddActifProps {
  users: any;
  openModalActif: () => void;
  modalIsOpenActif: boolean;
  closeModalActif: () => void;
  societes: Societe[];
  individus: Individu[];
  setLoading: (newvalue: boolean) => void;
}
const ModalAddActif = ({
  users,
  openModalActif,
  modalIsOpenActif,
  closeModalActif,
  societes,
  individus,
  setLoading,
}: ModalAddActifProps) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [addedActif, setAddedActif] = useState<Actif | null>(null);
  const [optionsinterlocuteur, setOptionsInterlocuteur] = useState<User[]>([]);
  const [optionsSociete, setOptionsSociete] = useState([]);
  const [optionsIndividu, setOptionsIndividu] = useState([]);
  const [selectedInterlocuteur, setSelectedInterlocuteur] =
    useState<User | null>(null);
  const [selectedOptionsSociete, setSelectedOptionsSociete] = useState([]);
  const [selectedOptionsIndividu, setSelectedOptionsIndividu] = useState([]);
  const [modals, setModals] = useState({
    societe: false,
    individu: false,
    correspondance: false,
  });
  const { reset } = useForm();

  const openModal = (modalName) => {
    setModals({ ...modals, [modalName]: true });
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
  };

  useEffect(() => {
    const mappedOptionsSociete = societes?.map((societe) => ({
      value: societe?.id,
      label: societe?.nom_societe,
    }));
    const mappedOptionsIndividu = individus?.map((individu) => ({
      value: individu.id,
      label: `${individu.nom_individu} ${individu.prenom_individu}`,
    }));

    setOptionsSociete(mappedOptionsSociete);
    setOptionsInterlocuteur(users);
    setOptionsIndividu(mappedOptionsIndividu);
  }, [users, societes, individus]);

  return (
    <>
      <CustomDialog
        header="Créer un nouvel actif"
        visible={modalIsOpenActif}
        closeModalDialog={() => {
          closeModalActif();
          reset();
          setAddedActif(null);
          setSelectedFile(null);
          setSelectedOptionsSociete([]);
          setSelectedInterlocuteur(null);
          setSelectedOptionsIndividu([]);
        }}
      >
        <div className="w-full h-full ">
          <div className="p-6 space-y-6">
            <FormAddActif
              setSelectedInterlocuteur={setSelectedInterlocuteur}
              setSelectedOptionsSociete={setSelectedOptionsSociete}
              setSelectedOptionsIndividu={setSelectedOptionsIndividu}
              setSelectedFile={setSelectedFile}
              setAddedActif={setAddedActif}
              closeModalActif={closeModalActif}
              openModal={openModal}
              selectedFile={selectedFile}
              optionsinterlocuteur={optionsinterlocuteur}
              selectedInterlocuteur={selectedInterlocuteur}
              optionsSociete={optionsSociete}
              selectedOptionsSociete={selectedOptionsSociete}
              optionsIndividu={optionsIndividu}
              selectedOptionsIndividu={selectedOptionsIndividu}
              addedActif={addedActif}
            />
          </div>
        </div>
      </CustomDialog>
      <ModalCorrespondanceActif
        closeModalCorrespondance={() => closeModal("correspondance")}
        openModalActif={openModalActif}
        modalIsOpenCorrespondance={modals.correspondance}
        addedActif={addedActif}
        setAddedActif={setAddedActif}
        setSelectedOptionsSociete={setSelectedOptionsSociete}
        setSelectedOptionsIndividu={setSelectedOptionsIndividu}
        setSelectedInterlocuteur={setSelectedInterlocuteur}
        setLoading={setLoading}
      />
      <ModalAddSociete
        openModalActif={openModalActif}
        closeModalSociete={() => closeModal("societe")}
        modalIsOpenSociete={modals.societe}
      />
      <ModalAddIndividu
        openModalActif={openModalActif}
        closeModalIndividu={() => closeModal("individu")}
        modalIsOpenIndividu={modals.individu}
      />
    </>
  );
};

export default ModalAddActif;
